// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
    const { isAdmin } = useAuth();

    // If admin is logged in, render the nested routes (via <Outlet />).
    // Otherwise, redirect them to the admin login page.
    return isAdmin ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;